import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Text = styled.p`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 19px;
  line-height: 120%;
  color: ${props => props.theme.secondaryColor};
  margin-top: 8px;
  margin-bottom: 0;

  > a {
    color: ${props => props.theme.secondaryColor};

    &:hover {
      color: ${props => props.theme.secondaryColor};
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

export default function Company({ name, slug }) {
  return (
    <Text>
      <a href={`/funds/${slug}`}>{name}</a>
    </Text>
  );
}

Company.propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};
